import { mean, std } from 'mathjs';

import { CompSelectionProperty } from '../../types.ts';
import { getQualityTierPrice } from './getQualityTierPrice.ts';

const MAX_QUALITY_TIERS = 10;

export const calcQualityTier = (properties: CompSelectionProperty[]): CompSelectionProperty[] => {
  const differences: number[] = [];
  const qualityTierProperties = properties
    .filter((p) => getQualityTierPrice(p) != null)
    .sort(
      (p1, p2) =>
        getQualityTierPrice(p2)!.toDollarLike() - getQualityTierPrice(p1)!.toDollarLike(),
    );
  const prices = qualityTierProperties.map((p) => getQualityTierPrice(p)!.toDollarLike());

  if (prices.length < 2) {
    return qualityTierProperties;
  }

  qualityTierProperties.forEach((p, i) => {
    if (i === 0) return;
    differences.push(Math.abs(prices[i]! - prices[i - 1]!));
  });

  const standardDeviation = std(differences) as unknown as number;
  const meanDifference = mean(differences);
  const naturalBreak = meanDifference + 2 * standardDeviation;

  let currentTier = 1;

  qualityTierProperties.forEach((p, i) => {
    if (i === 0) {
      p.qualityTier = currentTier;
    } else {
      const diff = differences[i - 1];
      if (diff && diff > naturalBreak && currentTier < MAX_QUALITY_TIERS) {
        currentTier++;
      }
      p.qualityTier = currentTier;
    }
  });

  return qualityTierProperties;
};
